import { Component } from "@angular/core";
import { MatDialog, MatDialogActions } from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-tutorial-popup",
    styleUrls: ["./tutorial-popup.component.css"],
    templateUrl: "./tutorial-popup.component.html",
    standalone: true,
    imports: [
        MatDialogActions,
        MatButton,
        IonicModule,
    ],
})
export class TutorialPopupComponent {
  constructor(private matDialog: MatDialog) {}

  public closeDialog() {
    this.matDialog.closeAll();
  }
}
